export default __webpack_public_path__ + "static/media/bmi.0c80d2f7.svg";